module.exports = {
	"contractName": "Fomo4D",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "changeOwner",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "0x608060405234801561001057600080fd5b506040805180820190915260098082527f426f5975204368656e000000000000000000000000000000000000000000000060209092019182526100559160009161005b565b506100f6565b828054600181600116156101000203166002900490600052602060002090601f016020900481019282601f1061009c57805160ff19168380011785556100c9565b828001600101855582156100c9579182015b828111156100c95782518255916020019190600101906100ae565b506100d59291506100d9565b5090565b6100f391905b808211156100d557600081556001016100df565b90565b6102b6806101056000396000f30060806040526004361061004b5763ffffffff7c010000000000000000000000000000000000000000000000000000000060003504166362a0947781146100505780638da5cb5b14610067575b600080fd5b34801561005c57600080fd5b506100656100f1565b005b34801561007357600080fd5b5061007c610159565b6040805160208082528351818301528351919283929083019185019080838360005b838110156100b657818101518382015260200161009e565b50505050905090810190601f1680156100e35780820380516001836020036101000a031916815260200191505b509250505060405180910390f35b3332148015906101075750610105336101e7565b155b151561011257600080fd5b6040805180820190915260088082527f42696c6c204873750000000000000000000000000000000000000000000000006020909201918252610156916000916101ef565b50565b6000805460408051602060026001851615610100026000190190941693909304601f810184900484028201840190925281815292918301828280156101df5780601f106101b4576101008083540402835291602001916101df565b820191906000526020600020905b8154815290600101906020018083116101c257829003601f168201915b505050505081565b6000903b1190565b828054600181600116156101000203166002900490600052602060002090601f016020900481019282601f1061023057805160ff191683800117855561025d565b8280016001018555821561025d579182015b8281111561025d578251825591602001919060010190610242565b5061026992915061026d565b5090565b61028791905b808211156102695760008155600101610273565b905600a165627a7a72305820cde9247fa3b0f4fdf80eb134a52bd5dbdd4a2480841474ca88c89d0268f5c9cd0029",
	"deployedBytecode": "0x60806040526004361061004b5763ffffffff7c010000000000000000000000000000000000000000000000000000000060003504166362a0947781146100505780638da5cb5b14610067575b600080fd5b34801561005c57600080fd5b506100656100f1565b005b34801561007357600080fd5b5061007c610159565b6040805160208082528351818301528351919283929083019185019080838360005b838110156100b657818101518382015260200161009e565b50505050905090810190601f1680156100e35780820380516001836020036101000a031916815260200191505b509250505060405180910390f35b3332148015906101075750610105336101e7565b155b151561011257600080fd5b6040805180820190915260088082527f42696c6c204873750000000000000000000000000000000000000000000000006020909201918252610156916000916101ef565b50565b6000805460408051602060026001851615610100026000190190941693909304601f810184900484028201840190925281815292918301828280156101df5780601f106101b4576101008083540402835291602001916101df565b820191906000526020600020905b8154815290600101906020018083116101c257829003601f168201915b505050505081565b6000903b1190565b828054600181600116156101000203166002900490600052602060002090601f016020900481019282601f1061023057805160ff191683800117855561025d565b8280016001018555821561025d579182015b8281111561025d578251825591602001919060010190610242565b5061026992915061026d565b5090565b61028791905b808211156102695760008155600101610273565b905600a165627a7a72305820cde9247fa3b0f4fdf80eb134a52bd5dbdd4a2480841474ca88c89d0268f5c9cd0029",
	"sourceMap": "26:400:11:-;;;70:48;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;94:19:11;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;94:19:11;:::i;:::-;;26:400;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;26:400:11;;;-1:-1:-1;26:400:11;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;",
	"deployedSourceMap": "26:400:11:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;295:129;;8:9:-1;5:2;;;30:1;27;20:12;5:2;295:129:11;;;;;;46:19;;8:9:-1;5:2;;;30:1;27;20:12;5:2;46:19:11;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:100:-1;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;46:19:11;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;295:129;333:10;347:9;333:23;;;;332:62;;;362:22;373:10;362;:22::i;:::-;:31;332:62;324:71;;;;;;;;401:18;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;401:18:11;:::i;:::-;;295:129::o;46:19::-;;;;;;;;;;;;;;;-1:-1:-1;;46:19:11;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;122:169::-;183:4;239:21;;278:8;;122:169::o;26:400::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;26:400:11;;;-1:-1:-1;26:400:11;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.18;\n\ncontract Fomo4D {\n  string public owner;\n\n  function Fomo4D() {\n    owner = \"BoYu Chen\";\n  }\n\n  function isContract(address _address) internal view returns (bool) {\n    uint256 size;\n\n    assembly {\n      size := extcodesize(_address)\n    }\n    return size > 0;\n  }\n\n  function changeOwner() {\n    require((msg.sender != tx.origin) && (isContract(msg.sender) == false));\n    owner = \"Bill Hsu\";\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Fomo4D.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Fomo4D.sol",
		"exportedSymbols": {
			"Fomo4D": [
				1290
			]
		},
		"id": 1291,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1238,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:11"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1290,
				"linearizedBaseContracts": [
					1290
				],
				"name": "Fomo4D",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 1240,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 1290,
						"src": "46:19:11",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_string_storage",
							"typeString": "string"
						},
						"typeName": {
							"id": 1239,
							"name": "string",
							"nodeType": "ElementaryTypeName",
							"src": "46:6:11",
							"typeDescriptions": {
								"typeIdentifier": "t_string_storage_ptr",
								"typeString": "string"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1247,
							"nodeType": "Block",
							"src": "88:30:11",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1245,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1243,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1240,
											"src": "94:5:11",
											"typeDescriptions": {
												"typeIdentifier": "t_string_storage",
												"typeString": "string storage ref"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "426f5975204368656e",
											"id": 1244,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "string",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "102:11:11",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_stringliteral_37df52924fac0098579857b25b2cb81eb21db34d70d26082789c0e99acf69f09",
												"typeString": "literal_string \"BoYu Chen\""
											},
											"value": "BoYu Chen"
										},
										"src": "94:19:11",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage",
											"typeString": "string storage ref"
										}
									},
									"id": 1246,
									"nodeType": "ExpressionStatement",
									"src": "94:19:11"
								}
							]
						},
						"documentation": null,
						"id": 1248,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "Fomo4D",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1241,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "85:2:11"
						},
						"payable": false,
						"returnParameters": {
							"id": 1242,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "88:0:11"
						},
						"scope": 1290,
						"src": "70:48:11",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1263,
							"nodeType": "Block",
							"src": "189:102:11",
							"statements": [
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1256,
											"name": "size",
											"nodeType": "VariableDeclaration",
											"scope": 1264,
											"src": "195:12:11",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 1255,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "195:7:11",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1257,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "195:12:11"
								},
								{
									"externalReferences": [
										{
											"size": {
												"declaration": 1256,
												"isOffset": false,
												"isSlot": false,
												"src": "231:4:11",
												"valueSize": 1
											}
										},
										{
											"_address": {
												"declaration": 1250,
												"isOffset": false,
												"isSlot": false,
												"src": "251:8:11",
												"valueSize": 1
											}
										}
									],
									"id": 1258,
									"nodeType": "InlineAssembly",
									"operations": "{\n    size := extcodesize(_address)\n}",
									"src": "214:63:11"
								},
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 1261,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1259,
											"name": "size",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1256,
											"src": "278:4:11",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1260,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "285:1:11",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "278:8:11",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 1254,
									"id": 1262,
									"nodeType": "Return",
									"src": "271:15:11"
								}
							]
						},
						"documentation": null,
						"id": 1264,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "isContract",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1251,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1250,
									"name": "_address",
									"nodeType": "VariableDeclaration",
									"scope": 1264,
									"src": "142:16:11",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1249,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "142:7:11",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "141:18:11"
						},
						"payable": false,
						"returnParameters": {
							"id": 1254,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1253,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1264,
									"src": "183:4:11",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1252,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "183:4:11",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "182:6:11"
						},
						"scope": 1290,
						"src": "122:169:11",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 1288,
							"nodeType": "Block",
							"src": "318:106:11",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 1281,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															},
															"id": 1272,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1268,
																	"name": "msg",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2937,
																	"src": "333:3:11",
																	"typeDescriptions": {
																		"typeIdentifier": "t_magic_message",
																		"typeString": "msg"
																	}
																},
																"id": 1269,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "sender",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "333:10:11",
																"typeDescriptions": {
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "!=",
															"rightExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1270,
																	"name": "tx",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2949,
																	"src": "347:2:11",
																	"typeDescriptions": {
																		"typeIdentifier": "t_magic_transaction",
																		"typeString": "tx"
																	}
																},
																"id": 1271,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "origin",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "347:9:11",
																"typeDescriptions": {
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																}
															},
															"src": "333:23:11",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														}
													],
													"id": 1273,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "332:25:11",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "&&",
												"rightExpression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"id": 1279,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1275,
																			"name": "msg",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 2937,
																			"src": "373:3:11",
																			"typeDescriptions": {
																				"typeIdentifier": "t_magic_message",
																				"typeString": "msg"
																			}
																		},
																		"id": 1276,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "sender",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": null,
																		"src": "373:10:11",
																		"typeDescriptions": {
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		}
																	],
																	"id": 1274,
																	"name": "isContract",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1264,
																	"src": "362:10:11",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_view$_t_address_$returns$_t_bool_$",
																		"typeString": "function (address) view returns (bool)"
																	}
																},
																"id": 1277,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "362:22:11",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "66616c7365",
																"id": 1278,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "bool",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "388:5:11",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																},
																"value": "false"
															},
															"src": "362:31:11",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														}
													],
													"id": 1280,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "361:33:11",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "332:62:11",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1267,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "324:7:11",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1282,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "324:71:11",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1283,
									"nodeType": "ExpressionStatement",
									"src": "324:71:11"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1286,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1284,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1240,
											"src": "401:5:11",
											"typeDescriptions": {
												"typeIdentifier": "t_string_storage",
												"typeString": "string storage ref"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "42696c6c20487375",
											"id": 1285,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "string",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "409:10:11",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_stringliteral_4156829ec8b244eafa6496960410cb08d9ddde0f3f53499a381222d819b4359a",
												"typeString": "literal_string \"Bill Hsu\""
											},
											"value": "Bill Hsu"
										},
										"src": "401:18:11",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage",
											"typeString": "string storage ref"
										}
									},
									"id": 1287,
									"nodeType": "ExpressionStatement",
									"src": "401:18:11"
								}
							]
						},
						"documentation": null,
						"id": 1289,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "changeOwner",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1265,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "315:2:11"
						},
						"payable": false,
						"returnParameters": {
							"id": 1266,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "318:0:11"
						},
						"scope": 1290,
						"src": "295:129:11",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 1291,
				"src": "26:400:11"
			}
		],
		"src": "0:427:11"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Fomo4D.sol",
		"exportedSymbols": {
			"Fomo4D": [
				1290
			]
		},
		"id": 1291,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1238,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:11"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1290,
				"linearizedBaseContracts": [
					1290
				],
				"name": "Fomo4D",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 1240,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 1290,
						"src": "46:19:11",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_string_storage",
							"typeString": "string"
						},
						"typeName": {
							"id": 1239,
							"name": "string",
							"nodeType": "ElementaryTypeName",
							"src": "46:6:11",
							"typeDescriptions": {
								"typeIdentifier": "t_string_storage_ptr",
								"typeString": "string"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1247,
							"nodeType": "Block",
							"src": "88:30:11",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1245,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1243,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1240,
											"src": "94:5:11",
											"typeDescriptions": {
												"typeIdentifier": "t_string_storage",
												"typeString": "string storage ref"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "426f5975204368656e",
											"id": 1244,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "string",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "102:11:11",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_stringliteral_37df52924fac0098579857b25b2cb81eb21db34d70d26082789c0e99acf69f09",
												"typeString": "literal_string \"BoYu Chen\""
											},
											"value": "BoYu Chen"
										},
										"src": "94:19:11",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage",
											"typeString": "string storage ref"
										}
									},
									"id": 1246,
									"nodeType": "ExpressionStatement",
									"src": "94:19:11"
								}
							]
						},
						"documentation": null,
						"id": 1248,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "Fomo4D",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1241,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "85:2:11"
						},
						"payable": false,
						"returnParameters": {
							"id": 1242,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "88:0:11"
						},
						"scope": 1290,
						"src": "70:48:11",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1263,
							"nodeType": "Block",
							"src": "189:102:11",
							"statements": [
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1256,
											"name": "size",
											"nodeType": "VariableDeclaration",
											"scope": 1264,
											"src": "195:12:11",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 1255,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "195:7:11",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1257,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "195:12:11"
								},
								{
									"externalReferences": [
										{
											"size": {
												"declaration": 1256,
												"isOffset": false,
												"isSlot": false,
												"src": "231:4:11",
												"valueSize": 1
											}
										},
										{
											"_address": {
												"declaration": 1250,
												"isOffset": false,
												"isSlot": false,
												"src": "251:8:11",
												"valueSize": 1
											}
										}
									],
									"id": 1258,
									"nodeType": "InlineAssembly",
									"operations": "{\n    size := extcodesize(_address)\n}",
									"src": "214:63:11"
								},
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 1261,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1259,
											"name": "size",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1256,
											"src": "278:4:11",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1260,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "285:1:11",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "278:8:11",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 1254,
									"id": 1262,
									"nodeType": "Return",
									"src": "271:15:11"
								}
							]
						},
						"documentation": null,
						"id": 1264,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "isContract",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1251,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1250,
									"name": "_address",
									"nodeType": "VariableDeclaration",
									"scope": 1264,
									"src": "142:16:11",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1249,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "142:7:11",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "141:18:11"
						},
						"payable": false,
						"returnParameters": {
							"id": 1254,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1253,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1264,
									"src": "183:4:11",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1252,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "183:4:11",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "182:6:11"
						},
						"scope": 1290,
						"src": "122:169:11",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 1288,
							"nodeType": "Block",
							"src": "318:106:11",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 1281,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															},
															"id": 1272,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1268,
																	"name": "msg",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2937,
																	"src": "333:3:11",
																	"typeDescriptions": {
																		"typeIdentifier": "t_magic_message",
																		"typeString": "msg"
																	}
																},
																"id": 1269,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "sender",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "333:10:11",
																"typeDescriptions": {
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "!=",
															"rightExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1270,
																	"name": "tx",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2949,
																	"src": "347:2:11",
																	"typeDescriptions": {
																		"typeIdentifier": "t_magic_transaction",
																		"typeString": "tx"
																	}
																},
																"id": 1271,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "origin",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "347:9:11",
																"typeDescriptions": {
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																}
															},
															"src": "333:23:11",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														}
													],
													"id": 1273,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "332:25:11",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "&&",
												"rightExpression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"id": 1279,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1275,
																			"name": "msg",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 2937,
																			"src": "373:3:11",
																			"typeDescriptions": {
																				"typeIdentifier": "t_magic_message",
																				"typeString": "msg"
																			}
																		},
																		"id": 1276,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "sender",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": null,
																		"src": "373:10:11",
																		"typeDescriptions": {
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		}
																	],
																	"id": 1274,
																	"name": "isContract",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1264,
																	"src": "362:10:11",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_view$_t_address_$returns$_t_bool_$",
																		"typeString": "function (address) view returns (bool)"
																	}
																},
																"id": 1277,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "362:22:11",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "66616c7365",
																"id": 1278,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "bool",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "388:5:11",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																},
																"value": "false"
															},
															"src": "362:31:11",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														}
													],
													"id": 1280,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "361:33:11",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "332:62:11",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1267,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "324:7:11",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1282,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "324:71:11",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1283,
									"nodeType": "ExpressionStatement",
									"src": "324:71:11"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1286,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1284,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1240,
											"src": "401:5:11",
											"typeDescriptions": {
												"typeIdentifier": "t_string_storage",
												"typeString": "string storage ref"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "42696c6c20487375",
											"id": 1285,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "string",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "409:10:11",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_stringliteral_4156829ec8b244eafa6496960410cb08d9ddde0f3f53499a381222d819b4359a",
												"typeString": "literal_string \"Bill Hsu\""
											},
											"value": "Bill Hsu"
										},
										"src": "401:18:11",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage",
											"typeString": "string storage ref"
										}
									},
									"id": 1287,
									"nodeType": "ExpressionStatement",
									"src": "401:18:11"
								}
							]
						},
						"documentation": null,
						"id": 1289,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "changeOwner",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1265,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "315:2:11"
						},
						"payable": false,
						"returnParameters": {
							"id": 1266,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "318:0:11"
						},
						"scope": 1290,
						"src": "295:129:11",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 1291,
				"src": "26:400:11"
			}
		],
		"src": "0:427:11"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.801Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Fomo4D.json
// module id = 1037
// module chunks = 0